import { Fragment } from "react";

/**
 * An answer option's label, with `inline code` rendered as code (pre-ship
 * 2026-10-18 QA-7: options showed the raw backticks, `` `len(x)` ``).
 *
 * DISPLAY ONLY. The option string itself is the answer — the radio / checkbox
 * value, the saved `selected_answer`, the server's exact-string scoring and
 * the cheat-proof twist all compare the RAW text — so this never changes what
 * is sent, only what is shown. Nothing but paired backticks is interpreted:
 * an option is not Markdown, and a lone backtick stays a backtick.
 */
export function OptionLabel({ text }: { text: string }) {
  return <>{splitInlineCode(text).map(renderPart)}</>;
}

export type OptionLabelPart = { code: boolean; text: string };

/** Split on paired backticks; an unpaired one stays literal text. */
export function splitInlineCode(text: string): OptionLabelPart[] {
  const parts: OptionLabelPart[] = [];
  const re = /`([^`]+)`/g;
  let last = 0;
  for (let m = re.exec(text); m !== null; m = re.exec(text)) {
    if (m.index > last) parts.push({ code: false, text: text.slice(last, m.index) });
    parts.push({ code: true, text: m[1] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ code: false, text: text.slice(last) });
  return parts;
}

function renderPart(part: OptionLabelPart, i: number) {
  return part.code ? (
    <code key={i} className="rounded bg-muted px-1 py-0.5 font-mono text-[0.9em]">
      {part.text}
    </code>
  ) : (
    <Fragment key={i}>{part.text}</Fragment>
  );
}
